import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import toastr from "toastr";
import apiServiceHandler from "../../service/apiService";

const Next90Modal = ({ isOpen, onClose }) => {
  const [textAreas, setTextAreas] = useState([""]);
  
  const [activeIndex, setActiveIndex] = useState(0);

  const textAreaRefs = useRef([]);

  useEffect(() => {
    if (isOpen) {
      const textArea = textAreaRefs.current[activeIndex];
      if (textArea) {
        textArea.focus();
        const length = textArea.value.length;
        textArea.setSelectionRange(length, length);
      }
    }
  }, [isOpen, activeIndex]);

  const handleAddTextarea = () => {
    setTextAreas([...textAreas, ""]);
  };

  const handleTextareaChange = (index, value) => {
    console.log(index === activeIndex, 'activeIndex', activeIndex, index)
    if (index === activeIndex) {
      const updatedTextAreas = [...textAreas];
      updatedTextAreas[index] = value;
      setTextAreas(updatedTextAreas);
    }
  };

  const handleFocus = (index) => {
    setActiveIndex(index);
  };

  const saveNext90 = async (e) => {
    e.preventDefault();

    if (!textAreas[0]) {
      toastr.error("Please enter a statement before saving.");
      return;
    }

    const updatedStatements = [...textAreas];

    const payload = {
      statement: updatedStatements,
      progress: 100,
    };

    try {
      const res = await apiServiceHandler("POST", "api/next90", payload);
      if (res.status) {
        toastr.success(res.message)
        onClose();
        setTextAreas([]);
      }
    } catch (error) {
      console.log("Failed to save next 90" + error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiServiceHandler("GET", "api/next90", {});
        if (res.status) {
          const statements = res.data.statement || [];
          setTextAreas(statements);
        }
      } catch (error) {
        console.error("Failed to fetch statements: " + error);
      }
    };
    fetchData();
  }, [isOpen]);

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="next90-modal"
    >
      <Modal.Header
        closeButton
        style={{
          borderBottom: "none",
          backgroundColor: "#26262f",
          color: "#d1b794",
        }}
      >
        <Modal.Title style={{ fontWeight: "400" }}>Next 90</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#26262f" }}>
        <div
          className="edit-key"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {textAreas.map((text, index) => (
            <textarea
              key={index}
              id={`textarea-${index}`}
              ref={(el) => (textAreaRefs.current[index] = el)}
              type="text"
              className="credo-input"
              value={text}
              onFocus={() => handleFocus(index)}
              onChange={(e) => handleTextareaChange(index, e.target.value)} // Update only the textarea at the correct index
              style={{
                marginBottom: "1rem",
                border: "1px solid #d1b794",
                width: "100%",
                minHeight: "100px",
              }}
            />
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          borderTop: "none",
          paddingTop: "1rem",
          backgroundColor: "#26262f",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <button type="button" className="save-next90-btn" onClick={saveNext90}>
            <span className="driver-button__label">SAVE</span>
          </button>
          <button
            type="button"
            className="more-btn"
            onClick={handleAddTextarea}
          >
            <span className="more-button__label">MORE</span>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default Next90Modal;
